import React, { createRef } from 'react';

import { observer } from 'mobx-react';
import { AnimateMovingItems } from '@bringg/react-components';

import { WorkflowRepoItem } from '../../../stores/unreadable-workflow';
import WorkflowRepoItemCard from '../../../components/workflow-repo-item-card/workflow-repo-item-card';

import styles from './workflows-list.module.scss';

interface Props {
	workflows: WorkflowRepoItem[];
	expandAll?: boolean;
	viewMode?: boolean;
}

const WorkflowsList = ({ workflows, expandAll, viewMode }: Props) => {
	return (
		<div className={styles.workflowList}>
			<AnimateMovingItems>
				{workflows.map(wf => (
					<WorkflowRepoItemCard
						viewMode={viewMode}
						key={wf.id}
						workflow={wf}
						ref={createRef()}
						expanded={expandAll}
					/>
				))}
			</AnimateMovingItems>
		</div>
	);
};

export default observer(WorkflowsList);
